import {isPresent} from '@republic/foundation/lang/is'

const
    isNative = () => window.navigator.product === 'ReactNative',
    isValue = value => isPresent(value) && value !== false

export {isNative, isValue}
